(function($) {

	'use strict';

	var init = function() {

        resizeIframe();
        
	}

	var resizeIframe = function(){

        $(window).resize(function(){

			$('iframe[src*="youtube"]').each(function() {
				var larg = $(this).width();
				$(this).height((larg * 9) / 16);
            })
            
        }).resize();

    }
    
    $(window).on('load', function() {
		init();
    });
    $(document).on('gform_post_render', function() {
        init();
    });

})(jQuery);